import { render, staticRenderFns } from "./AdTipsDetail.vue?vue&type=template&id=cf3cc8f2&scoped=true&"
import script from "./AdTipsDetail.vue?vue&type=script&lang=js&"
export * from "./AdTipsDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdTipsDetail.vue?vue&type=style&index=0&id=cf3cc8f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3cc8f2",
  null
  
)

export default component.exports